<!-- =========================================================================================
  File Name: AttendeeAdd.vue
  Description: Attendee Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.table-seating-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
}
.single-table-wrap {
  width: 33.33%;
  border-right: 1px solid #e2e2e2;
  min-height: 100%;
}
.single-table-wrap.no-border {
  border-right: none;
}
.single-table-wrap-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.attendee-catagory-wrapper {
  padding-right: 10px;
}
.single-attendee-catagory {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
}
.attendee-catagory-wrapper ul li {
  padding: 10px 0;
  transition: all 0.4s;
}
.attendee-catagory-wrapper ul li:hover {
  background: #f8f8f8;
  transition: all 0.4s;
}
.attendee-searchbox {
  position: relative;
}
.search-icon-search-box {
  position: absolute;
  top: 50%;
  left: 24px;
  transform: translateY(-50%);
}
.searchbox .vs-input--placeholder.normal {
  padding: 0.7rem 10px 0.7rem 3.2rem !important;
}
.attendee-list-select-wrap .vs-list--item,
.attendee-catagory-drop-wrap .vs-list--item {
  border-bottom: none;
  padding: 8px 0;
  position: relative;
}
.attendee-list-select-wrap .list-titles {
  padding-left: 30px;
}
.attendee-list-select-wrap .vs-list--slot {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.attendee-catagory-drop-wrap .host-wrapper .vs-list--item,
.attendee-catagory-drop-wrap .guest-wrapper .vs-list--item {
  padding: 8px 15px !important;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  display: block;
  margin-bottom: 15px;
}
span.cross-btn {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.attendee-guest-list-wrap {
  height: 400px;
  overflow-y: scroll;
  border: 2px dashed #bdbdbd;
  border-radius: 4px;
  margin-top: 5px;
}
.attendee-host-list-wrap{
  height: 410px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.attendee-list-wrap {
  height: 420px;
  overflow-y: scroll;
}
.bordered {
  border: 1px solid #f8b010;
}
.search-section{position: relative;}
.attendee-table-select-head{justify-content: space-between; align-items: center; display: flex;padding-right: 10px;}
.search-section .vs-input--placeholder.normal {padding: 10px 20px 10px 40px !important;}
.search-section .vs-input--input.normal {padding: 10px 20px 10px 40px !important;}
.search-icon{position: absolute; top: 50%; left: 5px; transform: translateY(-50%); line-height: 10px;}
</style>
<template>
  <div id="page-attendee-add">
    <div class="header-custome">
      <h3>Map attendees to Group</h3>
    </div>
    <vx-card>
      <div class="table-seating-wrapper">
        <div class="single-table-wrap">
          <!--<div class="single-table-wrap-top">
            <h5>Select Group</h5>-->
          <!--<vs-button color="primary" type="border">New</vs-button>-->
          <!--</div>
          <div class="attendee-catagory-wrapper mt-5">
            <ul>
              <li>
                <div class="single-attendee-catagory pl-3 active">
                  <p>All Attendees</p>
                  <p><feather-icon
                      class="iconsize"
                    icon="ChevronRightIcon"
                    />
                  </p>
                </div>
              </li>
            </ul>
          </div>-->
          <div class="single-table-wrap-top px-3 py-3">
            <h5>Drag and Drop Attendee(s) to your right ({{attendee_list.length}})</h5>
            <p>&nbsp;</p>
          </div>
          <div class="attendee-searchbox mt-0 mb-5 px-3">
            <vs-input
              icon="search"
              class="inputx w-full searchbox"
              placeholder="Search Attendee"
              v-model="attendeeName"
              @keyup="searchAttendee"
            />            
          </div>
          <div class="attendee-list-select-wrap">
            <div class="attendee-list-wrap">
              <draggable
                :list="attendee_search_list"
                :move="checkMoveSelected"
                :group="{ name: 'people', pull: 'clone', put: false }"
                class="p-2 cursor-move"
              >
                <vs-list-item
                  v-for="(listItem, index) in attendee_search_list"
                  :key="index"
                  :title="listItem.Name"
                  :subtitle="listItem.Email"
                >
                  <!--<vs-checkbox v-model="checkBox1"></vs-checkbox>-->
                </vs-list-item>
              </draggable>
            </div>
          </div>
        </div>
        <div class="single-table-wrap">
          <div class="single-table-wrap-top pl-3">
            <h5>Select Group</h5>
            
          </div>
          <div class="table-select-class px-3 mt-6">
            <div class="attendee-catagory-drop-wrap">
              <v-select
                placeholder="Select Group"
                class="track-select"
                label="GroupName"
                v-model="Group"
                :options="GroupList"
                
              />
            </div>
          </div>

          <div class="attendee-catagory-drop-wrap">
            <vs-list class="mt-5 ml-2">
              <div class="guest-wrapper">
                <div class="attendee-table-select-head d-flex">
                  Drag Attendee(s) or &nbsp;<a href="javascript:void(0)" @click="mapAllAttendees"> Map All</a> 
                  ({{guest_list.length}})

                  <vs-button size="small" class="ml-auto" @click="before_save"
                  >Save</vs-button
                >
                </div>
                <div class="attendee-guest-list-wrap">
                  <draggable
                    :list="guest_list"
                    :group="{ name: 'people', put: guestPut }"
                    class="p-2 cursor-move mt-5"
                  >
                    <vs-list-item
                      :class="
                        attendeesonothertable.includes(listItem.AttendeeId)
                          ? 'bordered'
                          : 'normal'
                      "
                      v-for="(listItem, index) in guest_list"
                      :key="index"
                      :title="listItem.FirstName+' '+listItem.LastName"
                      :subtitle="listItem.Email"
                    >
                      <span
                        class="cross-btn"
                        @click="removeGuest(listItem.AttendeeId)"
                        ><feather-icon class="iconsize" icon="XIcon"
                      /></span>
                    </vs-list-item>
                  </draggable>
                </div>
              </div>
            </vs-list>
          </div>
        </div>
        <div class="single-table-wrap no-border">
          <div class="attendee-catagory-drop-wrap pl-2">
            <vs-list>
              <div class="host-wrapper">
                <div class="single-table-wrap-top">
                  <div class="ml-2 attendee-table-select-head">
                   <h5>Attendees in this Group ({{host_list.length}})</h5>
                  </div>
                  <div class="button-group-area">
                    <vs-button
                      color="primary"
                      type="border"
                      size="small"
                      class=""
                      @click="$router.push('/event/groups')"
                      >Back to list</vs-button
                    >
                    <vs-button
                      color="primary"
                      type="border"
                      size="small"
                      @click="popupActive = true"
                      class="hidden"
                      >Bulk Import</vs-button
                    >
                  </div>
                </div>
                  <div class="search-section mt-2">
                    <vs-input class="inputx w-full" placeholder="Search" v-model="attendeeNameinGroup" @keyup="searchAttendeeinGroup" />
                    <div class="search-icon">
                      <feather-icon
                        class=""
                        icon="SearchIcon"
                        title="Search Icon"
                      />
                    </div>
                  </div>
                <div class="attendee-host-list-wrap mt-3">
                  <div class="vx-row">
                    <div class="vx-col md:w-1/1 w-full">
                      <draggable :list="host_list" :group="{ name: 'people', put: hostPut }" class="p-2 cursor-move mt-5">
                        <vs-list-item
                          v-for="(listItem, index) in host_list"
                          :key="index"
                          :title="listItem.FirstName +' '+ listItem.LastName"
                          :subtitle="listItem.Email"
                        >
                          <span
                            class="cross-btn"
                            @click="removeHost(listItem)"
                            ><feather-icon class="iconsize" icon="XIcon"
                          /></span>
                        </vs-list-item>
                      </draggable>
                    </div>

                  </div>
                  
                </div>
              </div>
            </vs-list>
          </div>
          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vs-popup
      class="holamundo"
      title="Import Round Table"
      :active.sync="popupActive"
    >
      <div class="import-attendee-wrapper">
        <div class="template-download">
          <h4>Download the template</h4>
          <a
            color="primary"
            type="filled"
            class="mt-3 btn"
            href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_RoundTable.xlsx?alt=media&token=af0ac634-c0d2-4034-baec-1e552285635f"
            >Download</a
          >
        </div>
        <div class="upload-file mt-5">
          <h4>Upload your file</h4>
          <div class="file-up-section">
            <p>Select XLSX file</p>
            <input
              type="file"
              id="roundtable_file"
              accept=".csv,.xlsx,.xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
            <vs-button
              color="rgb(76, 139, 246)" type="filled"
              class="sub-btn"
              v-on:click="UploadRoundTable"
              >Upload</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
// Store Module
import moduleroundtableManagementAdd from "@/store/roundtable-management/moduleRoundtableManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleAgendaManagement from "@/store/agenda-management/moduleAgendaManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";
import ls from "@/common/localStorage";
import vSelect from "vue-select";
import draggable from "vuedraggable";
var vm;
export default {
  components: {
    //attendeeEditTabInformation,
    "v-select": vSelect,
    draggable,
  },
  data() {
    return {
      //maxGuest: "11",
      topic: null,
      GroupList: [],
      attendee_list: [],
      attendee_search_list: [],
      host_list: [],
      host_list_before_search: [],
      guest_list: [],
      activeTab: 0,
      RoundTable: null,
      attendeeName: null,
      attendeeNameinGroup: null,
      hostPut: false,
      guestPut: true,
      popupActive: false,
      attendeesonothertable: [],
      Group: null
    };
  },
  watch: {
    validateForm() {
      return !this.errors.any();
    },
    Group(val){
      let GroupId = val ? val.GroupId : 0
      this.fetchAttendeesInGroup(GroupId)
    }
  },
  methods: {
    fetch_groups() {
      this.$store
        .dispatch("agendaManagement/fetchGroups")
        .then((res) => {
          this.GroupList = res;          
        });
    },
    fetchAttendeesInGroup(GroupId) {
      /*this.$store
        .dispatch("agendaManagement/fetchAttendeesInGroup", GroupId)
        .then((res) => {
         this.host_list_before_search = this.host_list = res;          
        });*/
        this.host_list_before_search = this.host_list = this.Group && this.Group.Attendees ? this.Group.Attendees : []; 
    },
    checkMoveSelected: function (evt) {
      //console.log(this.host_list.length)
      let ID = evt.draggedContext.element.AttendeeId;
      let Name = evt.draggedContext.element.Name;
      let found = this.host_list.some((el) => el.AttendeeId === ID);
      let foundl = this.guest_list.some((el) => el.AttendeeId === ID);
      if (found || foundl) {
        return false;
      } else {
        return true;
      }
    },
    removeHost(Attendee) {
      let id = Attendee.AttendeeId
      let index = this.host_list
        .map((x) => {
          return x.AttendeeId;
        })
        .indexOf(id);
      
      this.$vs.loading();
      this.$store.dispatch("agendaManagement/unmapAttendeestoGroup", {
        Group: this.Group,
        attendee_list: [Attendee]
      }).then((res) => {
        this.$vs.loading.close();
        this.host_list.splice(index, 1);
      })
    },
    removeGuest(id) {
      let index = this.guest_list
        .map((x) => {
          return x.AttendeeId;
        })
        .indexOf(id);

      this.guest_list.splice(index, 1);      
    },
    searchAttendee() {
      let attendeeName = this.attendeeName.trim().toLowerCase();
      if (attendeeName) {
        this.attendee_search_list = this.attendee_list.filter((row) => {
          if (
            String(row.FirstName).toLowerCase().includes(attendeeName) ||
            String(row.LastName).toLowerCase().includes(attendeeName) ||
            String(row.Email).toLowerCase().includes(attendeeName)
          ) {
            return true;
          } else {
            return false;
          }
        });
      } else {
        this.attendee_search_list = this.attendee_list;
      }
    },
    searchAttendeeinGroup() {
      let attendeeNameinGroup = this.attendeeNameinGroup.trim().toLowerCase();
      if (attendeeNameinGroup) {
        this.host_list = this.host_list_before_search.filter((row) => {
          if (
            String(row.FirstName).toLowerCase().includes(attendeeNameinGroup) ||
            String(row.LastName).toLowerCase().includes(attendeeNameinGroup) ||
            String(row.Email).toLowerCase().includes(attendeeNameinGroup)
          ) {
            return true;
          } else {
            return false;
          }
        });
      } else {
        this.host_list = this.host_list_before_search;
      }
    },
    before_save() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          resolve(result);
          if (result) vm.save_changes();
        });
      });
    },
    save_changes() {
      //console.log(this.host_list.length)
      //console.log(this.guest_list.length)
      /*this.guest_list.forEach(row => {
        if(row.Email == 'ndg_05@webspiders.com')
          console.log(row)
      })*/
      if (this.Group) {
        let Group = this.Group
        this.Group = null
        this.$vs.loading();
        this.$store
          .dispatch("agendaManagement/mapAttendeestoGroup", {
            Group: Group,
            host_list: this.host_list,
            guest_list: this.guest_list,
            attendee_list: this.guest_list
          })
          .then((res) => {
            if(res.status == 200){              
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Mapping",
                text: "Data Saved successfully.",
              });
            }
            else
            {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "Mapping",
                text: "Data not Saved!",
              });
            }
            this.$vs.loading.close();
            if(Group.Attendees)
            {
              Array.prototype.push.apply(Group.Attendees, this.guest_list); 
              console.log(Group.Attendees)
            }
            else
            {
              Group.Attendees = this.guest_list
            }
            this.guest_list = []
            this.Group = Group
          })
          .catch((err) => {
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "danger",
          title: "Mapping",
          text: "Group should be selected!",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    mapAllAttendees(){
      this.guest_list = this.attendee_search_list.filter(row => {
        let foundh = this.host_list.some(el => el.AttendeeId == row.AttendeeId)
        let foundg = this.guest_list.some(el => el.AttendeeId == row.AttendeeId)
        return !foundh && !foundg
      })
    },
    fetch_attendees() {
      this.$store
        .dispatch("attendeeManagement/fetchAttendees", null)
        .then((res) => {
          this.attendee_search_list = this.attendee_list = res.filter((row) => {
            return row.IsPublished && row.AttendeeId && row.FirstName;
          }).map(row=>{ 
            return {
              AttendeeId: String(row.AttendeeId)  ,
              Name: row.Name ? row.Name : null,
              FirstName: row.FirstName,
              LastName: row.LastName ? row.LastName : null,
              Email: row.Email ? row.Email : null
            }
          });
          this.attendee_list = this.attendee_list.sort((a, b) => {
            let fa = a.FirstName.toLowerCase();
            let fb = b.FirstName.toLowerCase();
            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          });

        });
    },
    fetch_group(GroupId){
      this.$store
        .dispatch("agendaManagement/fetchGroup", GroupId)
        .then((res) => {
          this.Group = res.data
        })
    },
    UploadRoundTable: function () {
      var files = document.getElementById("roundtable_file").files;
      bu.initVueComps(this.$vs);
      bu.StartUploadPrecss(files, "roundtable");
    },
  },
  created() {
    vm = this;
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }    
    this.fetch_attendees();
    if (!moduleAgendaManagement.isRegistered) {
      this.$store.registerModule("agendaManagement", moduleAgendaManagement);
      moduleAgendaManagement.isRegistered = true;
    }
    this.fetch_groups();
    this.fetch_group(this.$route.params.GroupId);
  },
};
</script>